import React, { useState } from "react";
import styled from "styled-components";
// Assets
import ContactImg1 from "../../assets/img/art2.PNG";
import ContactImg2 from "../../assets/img/art1.PNG";
import ContactImg3 from "../../assets/img/art.PNG";
import emailjs from "@emailjs/browser";
import Swal from "sweetalert2";
import { Spinner } from "../Elements/Spinner";

export default function Contact() {
  const [isLoading, setIsloading] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");
  const [formObj, setFormObj] = useState({
    companyName: "",
    contactName: "",
    phoneNo: "",
    email: "",
    spaceRequesting: "",
    description: "",
    truckingSupport: false,
    isProductHazardous: false,
    isControlledTemperature: false,
  });

  const changeHandler = (e) => {
    setErrorMsg("");
    setFormObj((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  const sendEmail = () => {
    setIsloading(true);
    if (
      formObj.companyName &&
      formObj.contactName &&
      formObj.phoneNo &&
      formObj.email &&
      formObj.spaceRequesting &&
      formObj.description
    ) {
      emailjs
        .send(
          "service_wsay4kh",
          "template_t3ei944",
          {
            to_name: `${formObj.contactName}-${formObj.email}`,
            from_name: `QUA LOGISTICS`,
            phoneNo: formObj.phoneNo,
            // to_email: [formObj.email],
            to_email: [
              "albertanderson@qualogistic.com",
              "gregoryquail@qualogistic.com",
            ],
            description: `${formObj.description}-${formObj.phoneNo}`,
            spaceRequesting: formObj.spaceRequesting,
            truckingSupport: formObj.truckingSupport ? "Yes" : "No",
            isProductHazardous: formObj.isProductHazardous ? "Yes" : "No",
            isControlledTemperature: formObj.isControlledTemperature
              ? "Yes"
              : "No",
          },
          "IuSFFVyIpm_2_a7Hg"
        )
        .then((result) => {
          setIsloading(false);
          setFormObj((prev) => ({
            ...prev,
            companyName: "",
            contactName: "",
            phoneNo: "",
            email: "",
            spaceRequesting: "",
            description: "",
            truckingSupport: false,
            isProductHazardous: false,
            isControlledTemperature: false,
          }));
          Swal.fire(
            "Confrimation!",
            "We have received your email and will be back to you soon!",
            "success"
          );
        })
        .catch(() => {
          setIsloading(false);
          Swal.fire(
            "Error!",
            "Something went wrong please try later!",
            "error"
          );
        });
    } else {
      setIsloading(false);
      setErrorMsg("All fields required*");
    }
  };
  return (
    <Wrapper id="contact">
      {isLoading && <Spinner />}
      <div className="lightBg">
        <div className="container">
          <HeaderInfo>
            <h1 className="font40 extraBold">Quick Quotes</h1>
            <p className="font13">
              With Quick Quotes, you can generate an online container shipping
              quote in just 30 seconds.
              <br />
              All you need is fill this form and we will contact you.
            </p>
          </HeaderInfo>
          <div className="row" style={{ paddingBottom: "30px" }}>
            <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6">
              <Form>
                <div className="row">
                  <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6">
                    <label className="font13">Company name:</label>
                    <input
                      type="text"
                      id="CompanyName"
                      name="companyName"
                      className="font20 extraBold"
                      onChange={changeHandler}
                      value={formObj.companyName}
                    />
                  </div>
                  <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6">
                    <label className="font13">Contact name:</label>
                    <input
                      type="text"
                      id="ContactName"
                      name="contactName"
                      className="font20 extraBold"
                      onChange={changeHandler}
                      value={formObj.contactName}
                    />
                  </div>
                </div>
                <label className="font13">Email:</label>
                <input
                  type="text"
                  id="email"
                  name="email"
                  className="font20 extraBold"
                  onChange={changeHandler}
                  value={formObj.email}
                />
                <div className="row">
                  <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6">
                    <label className="font13">phone #:</label>
                    <input
                      type="text"
                      id="phoneNo"
                      name="phoneNo"
                      className="font20 extraBold"
                      onChange={changeHandler}
                      value={formObj.phoneNo}
                    />
                  </div>
                  <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6">
                    <label className="font13">Space requesting (Sq. ft):</label>
                    <input
                      type="number"
                      id="spaceRequesting"
                      name="spaceRequesting"
                      className="font20 extraBold"
                      onChange={changeHandler}
                      value={formObj.spaceRequesting}
                    />
                  </div>
                </div>

                <textarea
                  rows="4"
                  cols="50"
                  type="text"
                  id="description"
                  name="description"
                  placeholder="Project description and details"
                  className="font20 extraBold"
                  onChange={changeHandler}
                  value={formObj.description}
                />
                <div style={{ display: "flex" }}>
                  <input
                    style={{ height: "20px", width: "20px" }}
                    type="checkbox"
                    id="truckingSupport"
                    name="truckingSupport"
                    onChange={changeHandler}
                    checked={formObj.truckingSupport}
                  />
                  <label
                    className="font13 mt-2"
                    style={{
                      marginTop: "4px",
                      marginLeft: "20px",
                    }}
                  >
                    Would this project need trucking support?
                  </label>
                </div>
                <div style={{ display: "flex" }}>
                  <input
                    style={{ height: "20px", width: "20px" }}
                    type="checkbox"
                    id="isProductHazardous"
                    name="isProductHazardous"
                    onChange={changeHandler}
                    checked={formObj.isProductHazardous}
                  />
                  <label
                    className="font13 mt-2"
                    style={{
                      marginTop: "4px",
                      marginLeft: "20px",
                    }}
                  >
                    Is this product considered hazardous?
                  </label>
                </div>
                <div style={{ display: "flex" }}>
                  <input
                    style={{ height: "20px", width: "20px" }}
                    type="checkbox"
                    id="isControlledTemperature"
                    name="isControlledTemperature"
                    onChange={changeHandler}
                    checked={formObj.isControlledTemperature}
                  />
                  <label
                    className="font13 mt-2"
                    style={{
                      marginTop: "4px",
                      marginLeft: "20px",
                    }}
                  >
                    Does this project require controlled temperatures?
                  </label>
                </div>
                {errorMsg && (
                  <ErrorWrapper>
                    <span>{errorMsg}</span>
                  </ErrorWrapper>
                )}
              </Form>
              <div style={{ textAlign: "center " }}>
                <button
                  class="btn btn-primary themeBg "
                  style={{
                    padding: "10px",
                    width: "200px",
                    borderRadius: "20px",
                    border: "1px solid #09295c",
                  }}
                  disabled={isLoading}
                  type="submit"
                  onClick={sendEmail}
                >
                  Send
                </button>
              </div>
            </div>
            <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6 flex">
              <div
                style={{ width: "50%" }}
                className="flexNullCenter flexColumn"
              >
                <ContactImgBox>
                  <img
                    src={ContactImg1}
                    style={{
                      width: "100%",
                    }}
                    alt="office"
                    className="radius6"
                  />
                </ContactImgBox>
                <ContactImgBox>
                  <img
                    src={ContactImg3}
                    style={{
                      width: "100%",
                    }}
                    alt="office"
                    className="radius6"
                  />
                </ContactImgBox>
              </div>
              <div style={{ width: "50%" }}>
                <div style={{ marginTop: "100px" }}>
                  <img
                    src={ContactImg2}
                    style={{
                      width: "100%",
                    }}
                    alt="office"
                    className="radius6"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Wrapper>
  );
}

const Wrapper = styled.section`
  width: 100%;
`;
const HeaderInfo = styled.div`
  padding: 70px 0 30px 0;
  @media (max-width: 860px) {
    text-align: center;
  }
`;
const Form = styled.form`
  padding: 70px 0 30px 0;
  input,
  textarea {
    width: 100%;
    background-color: transparent;
    border: 0px;
    outline: none;
    box-shadow: none;
    border-bottom: 1px solid #707070;
    height: 30px;
    margin-bottom: 15px;
  }
  textarea {
    min-height: 100px;
  }
  @media (max-width: 860px) {
    padding: 30px 0;
  }
`;
const ButtonInput = styled.input`
  border: 1px solid #103978;
  background-color: #1b50a3;
  width: 100%;
  padding: 15px;
  outline: none;
  color: #fff;
  :hover {
    background-color: #1b50a3;
    border: 1px solid #103978;
    color: #fff;
  }
  @media (max-width: 991px) {
    margin: 0 auto;
  }
`;
const ContactImgBox = styled.div`
  max-width: 180px;
  align-self: flex-end;
  margin: 10px 30px 10px 0;
`;
const SumbitWrapper = styled.div`
  @media (max-width: 991px) {
    width: 100%;
  }
`;
const ErrorWrapper = styled.section`
  color: red;
`;
